import enAs from '@/assets/locales/en-AS.json';
import enBr from '@/assets/locales/en-BR.json';
import ptAs from '@/assets/locales/pt-AS.json';
import ptBr from '@/assets/locales/pt-BR.json';
import esBr from '@/assets/locales/es-BR.json';
import esAs from '@/assets/locales/es-AS.json';
import { CountryEnum } from '@/enums/country.enum';
import { getCountry } from '@/store/util';
import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Cache from 'i18next-localstorage-cache';
import postProcessor from 'i18next-sprintf-postprocessor';

const _country = getCountry().toUpperCase();
const languageMap = {
  [CountryEnum.Argentina]: 'AS',
  [CountryEnum.Equador]: 'AS',
  [CountryEnum.Peru]: 'AS',
  [CountryEnum.Colombia]: 'AS',
  [CountryEnum.Chile]: 'AS',
  [CountryEnum.Uruguai]: 'AS',
  [CountryEnum.Brasil]: 'BR',
  [CountryEnum.RepublicaDominicana]: 'AS',
  [CountryEnum.Guatemala]: 'AS',
  [CountryEnum.ElSalvador]: 'AS',
  [CountryEnum.Panama]: 'AS',
};

export const i18nMixin = {
  methods: {
    i18n(text, properties) {
      let output = i18next.t(text, properties);

      if (output === text) {
        console.log(`No translation available for ${text}`);
        // console.trace();
        if (properties && properties.empty) {
          output = '';
        }
      }

      return output || '';
    },

    i18nSetup(callback) {
      i18next
        .use(Cache)
        .use(LanguageDetector)
        .use(postProcessor)
        .init({
          fallbackLng: `en-${languageMap[_country]}`,
          lng: this.mountLanguage(localStorage.getItem('language') || i18next.language),
          whitelist: [`en-${languageMap[_country]}`, `pt-${languageMap[_country]}`, `es-${languageMap[_country]}`],
          resources: {
            'pt-BR': { translation: ptBr },
            'pt-AS': { translation: ptAs },
            'en-BR': { translation: enBr },
            'en-AS': { translation: enAs },
            'es-BR': { translation: esBr },
            'es-AS': { translation: esAs },
          }
        }, callback);
    },

    mountLanguage(lng) {
      const lang = (lng || 'pt-BR').split('-');
      return `${lang[0]}-${languageMap[_country]}`;
    },

    getCurrentLanguage() {
      return localStorage.getItem('language') || i18next.language;
    },

    changeLanguage(lng) {
      const l = this.mountLanguage(lng);
      localStorage.setItem('language', l);
      i18next.changeLanguage(l);
      location.reload();
    },

    toggleLanguage() {
      if (i18next.language.indexOf('pt') >= 0) {
        this.changeLanguage(`en-${_country}`);
        return;
      }

      this.changeLanguage(`pt-${_country}`);
    }
  }
}
